export default "https://assets.egbcdn.net/assets/packs/_/images/app/manual/manual1-4e71f20d14836872783511303969146c.png";